import {
  downloadEventCsv,
  downloadIcs,
  googleCalendarUrl,
  outlookCalendarUrl,
  yahooCalendarUrl,
} from '../../utils/eventCalendarExport';

export default function EventCalendarActions({ event, className }) {
  if (!event) return null;

  return (
    <div className={['EventCalendar-actions', className].filter(Boolean).join(' ')}>
      <span className="EventCalendar-actions-label">Lisää kalenteriin:</span>
      <div className="EventCalendar-actions-buttons">
        <button type="button" className="Button Button-secondary EventCalendar-btn" onClick={() => downloadIcs(event)}>
          iCal
        </button>
        <a
          className="Button Button-secondary EventCalendar-btn"
          href={googleCalendarUrl(event)}
          target="_blank"
          rel="noopener noreferrer"
        >
          Google
        </a>
        <a
          className="Button Button-secondary EventCalendar-btn"
          href={outlookCalendarUrl(event)}
          target="_blank"
          rel="noopener noreferrer"
        >
          Outlook
        </a>
        <a
          className="Button Button-secondary EventCalendar-btn"
          href={yahooCalendarUrl(event)}
          target="_blank"
          rel="noopener noreferrer"
        >
          Yahoo
        </a>
        <button type="button" className="Button Button-secondary EventCalendar-btn" onClick={() => downloadEventCsv(event)}>
          CSV
        </button>
      </div>
    </div>
  );
}
